<template>
  <el-row>
    <el-col :span="4" class='main-logo'>
      <router-link to='/'>
        <div class="text-plus" style="color:#fff;">模板管理</div>
      </router-link>
    </el-col>
  <el-col :span="3"
            v-for="(nav,index) in navs"
            class='main-navItem'
            :class='{
              "jdypage-dropDown-nav nav-lg nav-fixe": nav.sub,
            }'
            :key='index'>
      <router-link :to="nav.path"
                   active-class='current'>
        <i class="icon" :class='nav.icons'></i>
        <span class='text'>{{nav.title}}</span>
      </router-link>
      <ul :style='{display:hideVal}'
          class="jdypage-dropDown-list"
          v-if='nav.sub'>
        <li class="jdypage-dropDown-item"
            v-for='(subnav,index) in nav.sub'
            :key='index'>
          <router-link :to="subnav.path"
                       active-class='current'
                       @click.native='hidelist'>
            <span>{{subnav.title}}</span>
          </router-link>
        </li>
      </ul>
    </el-col>
  </el-row>
</template>
<script>
  export default {
    name: 'Nav',
    data() {
      return {
        navs: [],
        hideVal: ''
      }
    },
    methods: {
      hidelist() {
        let me = this;
        let tim = ''
        me.hideVal = 'none',
          tim = setTimeout(function () {
            me.hideVal = '';
            clearTimeout(tim);
          }, 100)
      }
    },
    created() {
      this.navs = this.$identity.getNav()
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/nav-main.vue